<template>
    <EngineeringDashboard></EngineeringDashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const EngineeringDashboard = defineAsyncComponent(() =>
    import("../../components/Engineering/Dashboard/Dashboard.vue")
);

export default {
    name: "Engineering_Dashboard", //The name you are in should not equal the name of the component you are importing.
    components: { EngineeringDashboard, AuthLayout },
};
</script>
